export default {
    Menu: 'Meniu',
    Add: 'Adaugă',
    Modify: 'Modifică',
    Delete: 'Șterge',
    Scale: 'Redimensionează',
    Color: 'Culoare',
    Materials: 'Materiale',
    Mesh: 'Plasă',
    Size: 'Dimensiune',
    Details: 'Detalii',
    Quantity: 'Cantitate',
    AddToCart: 'Adaugă în coș',
    AddToCartTitle: 'Adaugă în coș',
    Cart: 'Coș',
    Total: 'Total',
    Subtotal: 'Subtotal',
    Shipping: 'Livrare',
    Shape: 'Formă',
    PickShape: 'Alegeți o formă de adăugat pe pânză',
    ShapeAdded: 'Formă adăugată. Faceți clic pe alta pentru a o înlocui.',
    Clipart: 'Ilustrație',
    PickClipart: 'Alegeți o ilustrație de adăugat pe pânză',
    ClipartAdded: 'Ilustrație adăugată. Faceți clic pe alta pentru a o înlocui.',
    SearchClipart: 'Căutați o ilustrație…',
    NoClipartFound: 'Nicio ilustrație găsită',
    Cliparts: 'Clipart',
    Illustration: 'Ilustrație',
    AiImage: 'Imagine IA',
    AiImageIntro: 'Descrieți ce doriți, alegeți un format și obțineți 2 propuneri.',
    AiImageFormat: 'Format',
    AiFormatSquare: 'Pătrat',
    AiFormatPortrait: 'Portret',
    AiFormatLandscape: 'Peisaj',
    AiImagePlaceholder: 'Ex.: o vulpe roșcată stilizată, stil plat, fundal transparent…',
    AiGenerate: 'Generează',
    AiGenerating: 'Se generează…',
    AiPickResult: 'Alegeți o propunere',
    AiImageAdded: 'Imagine adăugată pe pânză',
    AiImageError: 'Generarea imaginii a eșuat',
    AiNoResult: 'Nicio imagine generată',
    AiImageNotInPlan: 'Generarea de imagini IA nu este inclusă în planul dvs. Activați opțiunea pentru a o folosi.',
    SearchIllustration: 'Căutați o ilustrație…',
    NoIllustrationFound: 'Nicio ilustrație găsită',
    IllustrationIntro: 'Căutați ilustrații vectoriale de adăugat pe pânză.',
    IllustrationError: 'Căutarea ilustrațiilor a eșuat',
    IllustrationNotVector: 'Acest rezultat nu este un vector utilizabil',
    Texts: 'Texte',
    Images: 'Imagini',
    Colors: 'Culori',
    ThemeEditDesc: 'Modificați textele, imaginile și culorile temei.',
    ThemeNotFound: 'Temă negăsită.',
    ThemeNoEditable: 'Această temă nu conține elemente editabile.',
    Helpers: 'Rigle, ghidaje și grilă',
    Rulers: 'Rigle',
    RulersHint: 'Gradație în pixeli',
    Guides: 'Ghidaje',
    GuidesHint: 'Repere la 25 / 50 / 75 %',
    GridHint: 'Grilă suprapusă',
    Snapping: 'Aliniere magnetică',
    SnappingHint: 'Aliniază la centru / grilă / alte obiecte',
    LeaveConfirm: 'Sigur doriți să pierdeți modificările?',
    Products: 'Produse',
    Customization: 'Personalizare',
    BackToCustomizationType: 'Tip de personalizare',
    SaveNoChanges: 'Nicio modificare de salvat',
    ChooseCategory: 'Alegeți o categorie',
    SelectProduct: 'Alegeți un produs',
    Loading: 'Se încarcă',
    ProofLogoTooLarge: 'Logo prea mare (maximum 500 KB).',
    ProofLogoInvalidType: 'Format de imagine neacceptat.',
    ProofLogoImported: 'Logo importat.',
    ProofLogoImportFailed: 'Importul logoului a eșuat.',
    YouHaveProjects: 'Ai {count} proiect(e) în curs',
    ResumeProject: 'Reia un proiect',
    ResumeProjectHint: 'Continuă de unde ai rămas.',
    YourProjects: 'Proiectele tale în curs',
    OpenProject: 'Deschide acest proiect',
    NoProjects: 'Niciun proiect în curs.',
    AppUpdating: 'Se actualizează aplicația…',
    DraftRestored: 'Ciornă restaurată',
    SaveExpiredTitle: 'Salvare expirată',
    SaveExpiredMessage: 'Această salvare a expirat sau nu mai este disponibilă.',
    Continue: 'Continuă',
    PhotoFramePickShape: 'Alege un cadru',
    PhotoFramePlacePhoto: 'Plasează și ajustează fotografia',
    PhotoFrameChangePhoto: 'Schimbă fotografia',
    PhotoFrameDropTitle: 'Trage o fotografie aici',
    PhotoFrameDropSub: 'sau dă clic pentru a încărca',
    Rotation: 'Rotire',
    Reset: 'Resetează',
    ProofLogoTitle: 'Logo pentru BAT',
    ProofLogoUseSite: 'Păstrează logoul {site}',
    ProofLogoUseMine: 'Cu propriul meu logo',
    ProofLogoUseMineDesc: 'Doar pe BAT, nu pe fișierele de tipar.',
    ProofLogoNone: 'Fără niciun logo',
    ProofLogoDropTitle: 'Încarcă logoul tău',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Se validează comanda',
    LoadingStepScreenshots: 'Se generează previzualizările',
    LoadingStepPrintFile: 'Se generează fișierele de tipar',
    LoadingStepUpload: 'Se încarcă pe server',
    LoadingStepSave: 'Se salvează configurația',
    LoadingGraduation: 'Se încarcă gradația',
    OptimizingImage: 'Se optimizează imaginea',
    LoadingScene: 'Se încarcă scena',
    LoadingStepZip: 'Se creează arhiva zip',
    LoadingProduct: 'Se încarcă produsul',
    Category: 'Categorie',
    Product: 'Produs',
    Summary: 'Rezumat',
    Zone: 'Zonă',
    SelectZone: 'Selectați o zonă',
    SelectAZone: 'Alegeți o zonă',
    Undo: 'Anulează',
    Redo: 'Refă',
    Recenter: 'Centrează vizualizarea',
    HelpersIntro: 'Margini de zone, grilă, rigle și ghidaje pe pânza 2D.',
    ShowZoneBordersHint: 'Cadre de zone pe pânza principală',
    Save: 'Salvează',
    Saving: 'Se salvează',
    Grid: 'Grilă',
    SwitchTo3D: 'Comută la 3D',
    PrintZone: 'Zonă de imprimare',
    ViewModeSwitch: 'Mod de vizualizare',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Dublu',
    ShowZoneBorders: 'Afișează conturul zonelor',
    ShowZoneBordersHelp: 'Afișează/ascunde conturul punctat și eticheta zonelor pe pânza 2D.',
    ManageElements: 'Gestionează elementele',
    StartWithTheme: 'Începe cu o temă',
    Customize: 'Personalizează',
    FromThemeLibrary: 'Din biblioteca noastră de teme',
    StartFromScratch: 'Începe de la zero',
    Or: 'sau',
    PreviousCreations: 'Creații anterioare',
    WithModel: 'Cu un șablon',
    Search: 'Caută',
    SubCategory: 'Subcategorie',
    Next: 'Înainte',
    Previous: 'Înapoi',
    Validate: 'Validează',
    DownloadMyProject: 'Descarcă proiectul meu',
    EditThemeColors: 'Modifică culorile elementelor',
    AddPattern: 'Adaugă un fundal',
    EditGraduation: 'Modifică degradeul',
    Pattern: 'Fundal',
    PatternHint: 'Modelul este repetat pe toată zona de personalizare. Culorile sale pot fi personalizate.',
    SearchTheme: 'Caută o temă (titlu sau etichetă)',
    Theme: 'Temă',
    Graduation: 'Degrade',
    Graduation_s: 'Degrade(uri)',
    ErrorOccurred: 'A apărut o eroare.',
    ReloadPage: 'Reîncărcați pagina.',
    LoadingCategories: 'Se încarcă categoriile',
    ShowAll: 'Arată tot',
    Categories: 'Categorii',
    ComingSoon: 'În curând',
    DropImageHere: 'Trageți o imagine aici',
    ReleaseToImport: 'Eliberați pentru a importa',
    OrClickToBrowse: 'sau faceți clic pentru a răsfoi',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'Această metodă de imprimare funcționează cu culori definite. Vă recomandăm fișiere vectoriale pentru un rezultat optim.',
    SearchInPhotoGallery: 'Căutați în galeria noastră foto',
    QrCode: 'Cod QR',
    QrCodeContent: 'Conținut (URL, text, e-mail…)',
    QrCodePlaceholder: 'https://exemplu.com',
    QrCodeForeground: 'Culoare QR',
    QrCodeBackground: 'Fundal',
    QrCodeTransparentBg: 'Fundal transparent',
    QrCodeErrorLevel: 'Toleranță la erori',
    QrCodeErrorL: '7 % (densitate scăzută)',
    QrCodeErrorM: '15 % (standard)',
    QrCodeErrorQ: '25 %',
    QrCodeErrorH: '30 % (ridicată)',
    QrCodeEmptyPreview: 'Introduceți un conținut pentru previzualizare',
    QrCodeRequired: 'Conținutul codului QR este obligatoriu.',
    QrCodeInvalidUrl: 'Introduceți o adresă URL de cod QR validă (http:// sau https://).',
    QrCodeAdd: 'Adaugă codul QR',
    QrCodeEditOnlyColors:
        'După crearea unui cod QR, se pot modifica doar culorile. Pentru a-i schimba conținutul, ștergeți-l și creați unul nou.',
    ImageQualityGood: 'Rezoluție bună',
    ImageQualityMedium: 'Rezoluție medie',
    ImageQualityLow: 'Rezoluție scăzută – măriți imaginea sau reduceți-o pe pânză',
    LowQualityAlertTitle: 'Atenție',
    LowQualityAlertMessage:
        'Creația dvs. conține imagini de calitate scăzută sau prea mărite față de rezoluția lor originală. Corectați creația sau acceptați riscul de pixelare la imprimare.',
    LowQualityAlertHint: 'Prag de rezoluție scăzută:',
    LowQualityAcceptRisk: 'Accept riscul de pixelare pentru imaginile mele de calitate scăzută',
    Preview: 'Previzualizare',
    Bold: 'Aldin',
    Italic: 'Cursiv',
    Underline: 'Subliniat',
    FontSize: 'Dimensiune',
    SelectFont: 'Alegeți un font',
    UploadFont: 'Încarcă fontul meu',
    UploadFontHint: 'TTF sau OTF · max. 5 MB',
    CustomFontBadge: 'propriu',
    CustomFontImported: 'Font importat.',
    CustomFontFormatError: 'Format neacceptat (doar TTF sau OTF).',
    CustomFontTooLarge: 'Font prea mare (maximum 5 MB).',
    CustomFontImportFailed: 'Importul fontului a eșuat.',
    CustomFontRemoved: 'Font eliminat.',
    RecentFonts: 'Recente',
    Clear: 'Șterge',
    TextColor: 'Culoarea textului',
    TextOutline: 'Contur',
    AddOutline: 'Adaugă un contur',
    RemoveOutline: 'Elimină conturul',
    PickColor: 'Alegeți o culoare',
    PickThemeCategory: 'Alegeți o categorie pentru a explora temele',
    NoThemeInCategory: 'Nicio temă în această categorie',
    ThemePreviewLabel: 'Previzualizarea temei',
    PickAnotherTheme: 'Alegeți altă temă',
    Keep: 'Păstrează',
    LoadingThemes: 'Se încarcă temele',
    LoadingPatterns: 'Se încarcă fundalurile',
    EditableThemeColors: 'Culori editabile ale elementelor',
    PickAColor: 'Alegeți o culoare',
    SelectALayout: 'Selectați un șablon',
    CreateLayer: 'Creează un element',
    LastDownloads: 'Ultimele descărcări',
    Cancel: 'Anulează',
    Back: 'Înapoi',
    BackToProvider: 'Înapoi la {provider}',
    LayerNotFound: 'Elementul nu a fost găsit',
    ChangeImage: 'Schimbă imaginea',
    ChangePattern: 'Schimbă fundalul',
    Resize: 'Redimensionează',
    RemoveBackground: 'Elimină fundalul',
    Processing: 'Se procesează…',
    AddFilter: 'Adaugă un filtru',
    PhotoCredit: 'Foto de {author} pe {provider}',
    PhotoBy: 'Foto de',
    On: 'pe',
    LinkRedirectionWarning: 'Acest link vă va redirecționa către acest site web',
    LoadMore: 'Încarcă mai mult',
    EditLayer: 'Editează elementul',
    Import: 'Importă',
    FromYourDevice: 'De pe dispozitivul dvs.',
    FromImageGallery: 'Din galeria de imagini',
    NoGraduationsAvailable: 'Niciun degrade disponibil',
    Confirm: 'Confirmă',
    CustomizeProduct: 'Personalizați-vă produsul',
    WriteYourText: 'Scrieți textul aici',
    Text: 'Text',
    Image: 'Imagine',
    DesignSummary: 'Rezumatul designului dvs.',
    AddOptions: 'Adaugă opțiuni',
    TermsOfSale: 'Condiții generale de vânzare',
    TOSMessage:
        'Certific că creația mea este conformă cu [Condițiile generale de vânzare](#) și în special cu articolul 8 - Proprietate intelectuală',
    IValidateMyCreation: 'Îmi validez creația',
    FunctionalityNotAvailable: 'Funcționalitate indisponibilă',
    Lock: 'Blochează',
    Unlock: 'Deblochează',
    AddLayer: 'Adaugă un element',
    LayerSectionTemplates: 'Șabloane',
    LayerSectionText: 'Text și date',
    LayerSectionImages: 'Imagini',
    LayerSectionDecor: 'Decor',
    LayerSectionTools: 'Instrumente',
    DragLayersToReorder: 'Trageți straturile pentru a le reordona',
    PleaseAgreeTOS: 'Acceptați condițiile generale pentru a valida creația.',
    ErrorExportPrintFile: 'A apărut o eroare la exportul fișierului de imprimare.',
    ErrorExportProofFile: 'A apărut o eroare la exportul bunului de tipar.',
    ErrorAddToCart: 'A apărut o eroare la adăugarea în coș: ',
    Gabarit: 'Șablon',
    FicheTechnique: 'Fișă tehnică',
    GeneratingPrintFile: 'Se generează fișierul de imprimare…',
    GeneratingProofFile: 'Se generează bunul de tipar…',
    LeaveCustomizer: 'Părăsiți configuratorul',
    LeaveManager: 'Părăsiți gestionarul de elemente',
    ChangeProductTitle: 'Creația dvs. va fi ștearsă.',
    ChangeProductConfirm: 'Schimbarea produsului vă va șterge definitiv creația, sunteți sigur?',
    Duplicate: 'Duplică',
    LoadingTheme: 'Se încarcă tema',
    LoadingPattern: 'Se încarcă fundalul',
    Expand: 'Mărește',
    Shrink: 'Micșorează',
    TiltLeft: 'Înclină la stânga',
    TiltRight: 'Înclină la dreapta',
    Rotate: 'Rotește',
    Move: 'Mută',
    Reposition: 'Repoziționează',
    MoveUp: 'Mută în sus',
    MoveDown: 'Mută în jos',
    MoveLeft: 'Mută la stânga',
    MoveRight: 'Mută la dreapta',
    NoCustomization: 'Nu există personalizare pe produs.',
    MissingCustomization: 'Personalizare lipsă',
    SelectGraduation: 'Selectați un degrade',
    ProofTitle: 'Bun de tipar',
    ProofDesignTitle: 'Personalizare 2D',
    ProofScreenshotsTitle: 'Vederi 3D',
    ProofSelectedInksTitle: 'Culori selectate',
    Warning: 'Atenție',
    SelectZoneBeforeTheme: 'Selectați o zonă înainte de a alege o temă.',
    ThemeTooManyElements: 'Tema conține prea multe elemente. Alegeți alta',
    Error: 'Eroare',
    ProductNotFound: 'Produs negăsit',
    ProductNotFoundMessage: 'Produs negăsit, veți fi redirecționat către pagina principală.',
    NoCategoryAvailable: 'Nicio categorie disponibilă',
    CategoryNotFound: 'Categorie negăsită',
    CategoryNotFoundMessage: 'Categorie negăsită, veți fi redirecționat către pagina principală.',
    Unavailable: 'Indisponibil',
    SavedConfigurations: 'Configurații salvate',
    YourSavedConfigurations: 'Configurațiile dvs. salvate',
    NoSavedConfigurations: 'Nicio configurație salvată pentru acest produs',
    ConfigurationName: 'Numele configurației',
    Created: 'Creat',
    Expires: 'Expiră',
    Load: 'Încarcă',
    ConfirmDeleteConfiguration: 'Sigur doriți să ștergeți această configurație?',
    Close: 'Închide',
    Step: 'Pas',
    CustomizeProductDesc: 'Alegeți cum începeți: creație liberă sau pornind de la o temă propusă mai jos.',
    StartFromScratchDesc: 'O pânză goală pentru a adăuga texte, imagini și forme, fără șablon impus.',
    ChooseProductDesc: 'Alegeți un produs de personalizat.',
    PrintMethod: 'Metodă de imprimare',
    ChoosePrintMethod: 'Alegeți metoda dvs.',
    ChoosePrintMethodDesc:
        'Selectați metoda de imprimare pentru acest produs. Această alegere este definitivă pentru această personalizare.',
    Digital: 'Digital',
    ScreenPrinting: 'Serigrafie',
    LaserEngraving: 'Gravură laser',
    Embroidery: 'Broderie',
    RestrictedToPalette: 'Culori limitate la paletă',
    ChooseInks: 'Alegeți cernelurile',
    ChooseThreads: 'Alegeți firele',
    AppliesToZone: 'Zonă: {zone}',
    Ink: 'Cerneală',
    Thread: 'Fir',
    InkOverride: 'Forțează o cerneală',
    ThreadOverride: 'Forțează un fir',
    SuggestInks: 'Cerneluri sugerate',
    SuggestThreads: 'Fire sugerate',
    RecommendColorsFromImage: 'Recomandă culori din imagine',
    NoColorSuggestion: 'Nicio sugestie de culoare pentru această imagine.',
    InkAssistantHelp: 'Această metodă folosește o paletă de {count} culori fixe.',
    InkAssistantQuestion: 'Cum doriți să vă definiți culorile?',
    InkAssistantUpload: 'Ajută-mă să-mi găsesc culorile',
    InkAssistantUploadDesc:
        'Importați imaginea, logoul sau modelul – detectăm automat cele mai apropiate culori din paletă.',
    InkAssistantManual: 'Îmi aleg culorile manual',
    InkAssistantManualDesc: 'Selectați fiecare culoare, una câte una, din paletă.',
    InkAssistantAnalyzing: 'Se analizează imaginea…',
    InkChoiceModifiableHint: 'Această alegere poate fi modificată oricând.',
    InkAssistantResultDesc: 'Iată culorile din paletă cele mai apropiate de imaginea dvs.',
    InkDuplicateWarning:
        'Această culoare este deja selectată pentru altă cerneală / fir. Selectând-o a doua oară veți contopi definitiv culorile. Sunteți sigur?',
    Selected: 'Selectat',
    VectorizeImage: 'Vectorizează imaginea',
    Vectorizing: 'Se vectorizează…',
    VectorizePreviewTitle: 'Rezultatul vectorizării',
    VectorizeIntro:
        'Imaginea va fi convertită în vector și limitată la cernelurile alese. Validați rezultatul pentru a-l aplica.',
    VectorizeApply: 'Aplică vectorul',
    VectorizeConsent:
        'Înțeleg că sunt responsabil pentru controlul rezultatului vectorizării și că imprimarea îl va reflecta.',
    VectorizeThreshold: 'Prag (detaliu / fundal)',
    VectorizeThresholdHint:
        'Reglați pragul pentru a rafina: mai jos elimină mai mult fundal deschis (line-art); mai sus păstrează mai multe zone deschise.',
    VectorizeCancel: 'Anulează',
    VectorizeFailed: 'Vectorizarea a eșuat. Încercați din nou sau schimbați imaginea.',
    Before: 'Înainte',
    After: 'După',
    VariableText: 'Text variabil',
    VariableTextIntro:
        'Această funcție seamănă cu un mailing și vă permite să obțineți produsul imprimat într-un exemplar unic pentru fiecare text; cantitatea este calculată automat pentru coș.',
    VariableTextData: 'Date (o linie = un exemplar)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'Importă un CSV / Excel',
    SessionImages: 'Imagini importate',
    Accept: 'Acceptă',
    UploadConsentMessage:
        'Confirm că niciunul dintre fișierele mele nu încalcă legile în vigoare, drepturile de autor sau drepturile terților.',
    VariableTextNoData: 'Adăugați cel puțin o linie pentru previzualizare.',
    VdpFields: 'Câmpuri variabile',
    VdpFieldName: 'Numele câmpului',
    VdpPlace: 'Plasează',
    VdpPlaced: 'Plasat',
    VdpAddField: 'Adaugă un câmp',
    VdpAddRow: 'Adaugă o linie',
    VdpLine: 'Rând',
    VdpEnterData: 'Introdu datele mele',
    Done: 'Gata',
    VdpFieldStyle: 'Stilul câmpului',
    VdpFirstRowHeader: 'Prima linie = antet (numele câmpurilor)',
    VdpQuantity: 'Cantitate: {qty}',
    VdpQuantityHint: 'Cantitatea este impusă de numărul de linii ale textului variabil.',
    VariableTextOnlyOne: 'Un singur câmp de text variabil per creație.',
    VariableTextEmptyFile: 'Fișier gol sau fără coloană utilizabilă.',
    VariableTextImportError: 'Acest fișier nu poate fi citit. Folosiți un CSV sau lipiți textul.',
    VariableTextExcelUnavailable: 'Citirea Excel indisponibilă. Exportați în CSV sau lipiți textul.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks:
        'Cerneluri selectate: {chosen}/{required}. Alegeți toate cernelurile înainte de a valida.',
    PreflightScreenColorCount: 'Serigrafie: creația dvs. este limitată la {count} cerneală/cerneluri.',
    PreflightMinStroke: 'Grosime minimă recomandată a liniei: {mm} mm. Liniile mai fine se pot imprima prost.',
    PreflightMinFont: 'Dimensiune minimă recomandată a fontului: {pt} pt.',
    PreflightLaserMonochrome: 'Gravură laser: rezultatul final va fi monocrom.',
    More: 'Altele',
    All: 'Toate',
    AllCategories: 'Toate categoriile',
    SearchCategory: 'Căutați o categorie…',
    NoProductAvailable: 'Niciun produs în această categorie.',
    ChooseProductTitle: 'Alege produsul de personalizat',
    PrintMethodQuestion: 'Cum vrei să imprimi {product}?',
    PrintMethodIntro:
        'Fiecare metodă are punctele sale forte și limitările sale — definește culorile și finisajele disponibile ulterior.',
    StartLabel: 'Punct de plecare',
    StartTitle: 'Începe de la o temă sau o pagină goală',
    StartIntro: 'O temă = un design gata de retușat (cel mai rapid). Pagină goală = control total.',
    StepProduct: 'Produs',
    StepMethod: 'Metodă',
    StepStart: 'Start',
    StepDesign: 'Design',
    ChangeTheme: 'Schimbă tema',
    BackToTheme: 'Înapoi la temă',
    Recent: 'Recente',
    WhiteNotPrintable: 'Albul nu poate fi imprimat (transparent).',
    LoginToSave: 'Autentifică-te pentru a-ți regăsi creațiile în contul tău.',
    Login: 'Autentificare',
    LoggingIn: 'Se autentifică…',
    ContinueWithoutAccount: 'Continuă fără cont',
    SaveEmailPlaceholder: 'Adresa ta de e-mail',
    SaveEmailHint: 'Vei primi un link pentru a-ți relua proiectul (păstrat 30 de zile).',
    SaveConfirmTitle: 'Proiect salvat',
    SaveConfirmMessage: 'Proiectul tău a fost salvat. Tocmai ți-am trimis un e-mail cu linkul de reluare.',
    DisableEmbroideryEffect: 'Dezactivează efectul de broderie',
    AddThread: 'Adaugă un fir',
    RemoveThread: 'Elimină un fir',
    VectorizeDenoise: 'Reducere zgomot',
    VectorizeDenoiseHint: 'Elimină petele și punctele mici nedorite.',
    VectorizeSmoothing: 'Netezire',
    VectorizeSmoothingHint: 'Rotunjește contururile (mai puține colțuri).',
    ZoomIn: 'Mărește',
    ZoomOut: 'Micșorează',
    Fit: 'Încadrează',
    Apply: 'Aplică',
    Edit: 'Editează',
    Support: 'Asistență',
    VectorizeAcknowledge:
        'Înțeleg că sunt responsabil de verificarea rezultatului vectorizării și că imprimarea îl va reflecta.',
    Crop: 'Decupează',
    Font: 'Font',
    Style: 'Stil',
    Outline: 'Contur',
    Steps: 'Pași',
    Tools: 'Instrumente',
    ThemeColors: 'Culori',
    Minimize: 'Minimizează',
    MoveLayerUp: 'Mută stratul în sus',
    MoveLayerDown: 'Mută stratul în jos',
    DragLayer: 'Trage pentru a reordona',
    NoResult: 'Niciun rezultat',
    SearchElement: 'Caută un element…',
    ExpertMode: 'Mod expert',
    Finish: 'Finalizează',
    ChooseImageOrPhoto: 'Alege o imagine sau o fotografie',
    WizardIntro: 'Urmează pașii pentru o creație personalizată în 1 minut.',
    WizardIntroExpert: 'Vrei mai multă libertate? Treci la modul expert.',
    ClickToChooseImage: 'Fă clic aici pentru a alege o imagine sau o fotografie',
    ChooseCategoryDesc: 'Selectează o familie de produse pentru a începe.',
    SelectProductDesc: 'Selectează un produs pentru a începe…',
    FinalReview: 'Ultimul pas',
    StartWithThemeDesc: 'Pornește de la un design preconfigurat.',
    WithModelDesc: 'Alege un șablon gata făcut.',
    ExpertModeConfirmTitle: 'Mod expert',
    ExpertModeConfirmMsg:
        'Trecerea la modul expert este o alegere definitivă. Acest mod este puțin mai complex de utilizat, dar îți permite să adaugi și să modifici elemente fără restricții.',
    ExpertModeHint: 'Completează-ți creația fără limite – adaugă text și fotografii cum dorești.',
    VariableData: 'Date variabile',
    PhotoFrame: 'Ramă foto',
    PhotoFrameHint: 'Alege o formă, apoi pune o fotografie în interior.',
    PhotoFrameChooseShape: '1. Forma ramei',
    PhotoFrameChangeShape: 'Schimbă forma',
    PhotoFramePickPhoto: 'Alege o fotografie',
    FromLibrary: 'Din bibliotecă',
    VdpMaxRowsReached: 'Stoc maxim atins',
    VdpImportTruncated: 'Import limitat la stocul disponibil',
    LetterSpacing: 'Spațiere între litere',
    OutlineActive: 'Contur activat',
    OutlineThickness: 'Grosimea conturului',
    AlignLeft: 'Aliniere la stânga',
    AlignCenter: 'Centrare',
    AlignRight: 'Aliniere la dreapta',
    Uppercase: 'Majuscule',
    TextFormatting: 'Formatare',
    FontSizeLabel: 'Dimensiunea fontului',
    SelectionActions: 'Acțiuni pentru selecție',
    DragToMove: 'Trage pentru a muta',
    DragToResize: 'Trage pentru a redimensiona',
    DragToRotate: 'Trage pentru a roti',
    MoveUpOneLevel: 'Mută cu un nivel mai sus',
    MoveDownOneLevel: 'Mută cu un nivel mai jos',
    BringToFront: 'Adu în prim-plan',
    Front: 'Prim-plan',
    SendToBack: 'Trimite în fundal',
    BackgroundNeverUnderPattern: 'Fundal (niciodată sub un model de fundal)',
    EyedropperColor: 'Pipetă de culoare',
    PresetColors: 'Culori predefinite',
    RecentColors: 'Culori recente',
    Palette: 'Paletă',
    HexValue: 'Valoare hexazecimală',
    AiResultsHint: 'Găsești toate sugestiile în fila Imagine',
    Notifications: 'Notificări',
    Zoom: 'Zoom',
    GuidedCustomization: 'Personalizare ghidată',
    Actions: 'Acțiuni',
    InkAssistantYourChoice: 'Ai ales:',
    InkAssistantCorrectQuestion: 'Doriți să corectați această alegere?',
    '': ''
};
